export default __webpack_public_path__ + "static/media/part-plus.92a805a0.svg";